import React from "react";
const AppContext = React.createContext({});
export const AppsProvider = AppContext.Provider;
export default AppContext;
